"use client";

import { SectionEventsDescription } from "./SectionEventsDescription";

export const PageAbout = () => {
  return (
    <>
      <SectionEventsDescription marginTop={20} marginBottom={20} />
    </>
  );
};
